import { PROMO_BANNER_LINK } from './header';

const HIDE_PROMO_BANNER_PATTERN_PATHS = [PROMO_BANNER_LINK];

export const shouldHidePromoBannerOnPagePath = (path: string | null) =>
  !!path && HIDE_PROMO_BANNER_PATTERN_PATHS.some((excludedPath) => path.includes(excludedPath));
